import React, { useState, useEffect, useRef } from 'react'
import location from '../../Assets/img/location.svg'
import naira from '../../Assets/img/naira.svg'
import { NavLink, useNavigate } from 'react-router-dom'
import Loader from '../../Components/Loader'
import moment from 'moment'
import 'add-to-calendar-button/assets/css/atcb.css'
import TicketDate from '../../Components/TicketDate'
import { Row, Col, Modal, Button } from 'reactstrap'

import ReactImageVideoLightbox from 'react-image-video-lightbox'
import MobileMenu from './MobileMenu'
import Footer from '../../Components/AppLayout/Footer'
import 'react-alice-carousel/lib/alice-carousel.css'
import axios from '../../Utils/axios'
import Header from '../../Components/Header'
import { fecthLowerPrice } from '../../Utils/helper'
import SearchedEvent from '../../Components/EventsCard/SearchedEvent'
import EventDetails from '../../Components/Events/Details'
import { useGetFeaturedEventQuery } from '../../Client/Event'


const Intent = () => {
  const navigate = useNavigate()

  const [searchEvent, setSearchEvent] = useState('')
  const [showEventDetails, setShowEventDetails] = useState(false)
  const [activeTab, setActiveTab] = useState('event-details')
  const [checked, setChecked] = useState(false)
  const [coupon, setCoupon] = useState(false)
  const [colorChange, setColorchange] = useState(false)
  const [showMobileMenu, setShowMobileMenu] = useState(false)
  const [showDropdown, setShowDropdown] = useState(false)
  const [showMobileSearch, setShowMobileSearch] = useState(false)
  const [allEvents, setAllEvents] = useState([])
  const [allFeaturedEvents, setAllFeaturedEvents] = useState([])
  const [filteredEvents, setFilteredEvents] = useState([])
  const [apiKey, setApiKey] = useState(null)
  const [selectedEvent, setSelectedEvent] = useState(null)
  const [featureType, setFeatureType] = useState('scroll')
  const [mainFeaturePicture, setMainFeaturePicture] = useState('')
  const [loading, setLoading] = useState(false)
  const [request, setRequest] = useState(false)
  const [fetching, setFetching] = useState(false)
  const [activeSlide, setActiveSlide] = useState(0)
  const [totalPrice, setTotalPrice] = useState(0)

  const [ticketOrderDetails, setTicketOrderDetails] = useState([])
  const [heroEvent, setHeroEvent] = useState(null)
  const [searchValue, setSearchValue] = useState('')
  const [categoryValue, setCategoryValue] = useState('')
 
  const [createEvent, setCreateEvent] = useState(false)
  const [name, setFullname] = useState('')
  const [matches, setMatches] = useState()
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [init, setInit] = useState(false)
  const [error, setError] = useState(false)
  const [showEventImages, setShowEventImages] = useState(false)

  const videoRef = useRef()

  const handleVideoPlay = () => {
    if (videoRef.current) {
      videoRef.current.play()
    }
  }
  
  function isElementInView(element) {
    const rect = element.getBoundingClientRect()
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight
    const windowWidth =
      window.innerWidth || document.documentElement.clientWidth

    // Check if any part of the element is within the viewport
    const isElementVisible =
      rect.top <= windowHeight &&
      rect.bottom >= 0 &&
      rect.left <= windowWidth &&
      rect.right >= 0

    return isElementVisible
  }
  function scrollToView(element) {
    if (!isElementInView(element)) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }
  const { featuredEvents: newFeaturedEvents, isLoading: featured_loading, error: featured_error } = useGetFeaturedEventQuery()
  const reset = () => {
    setActiveTab('event-details')
    const orderValue = Array.from(
      document.getElementsByClassName('ticket-order-value')
    )
    orderValue.map((el, i) => (el.innerHTML = 0))
    setTicketValue(0, 'reset')
    setTicketOrderDetails([])
  }
  
  const toggleSimilarEventDetails = () => {
    reset()

    window.scrollTo(0, 0)
    const el = document.querySelector('#close-modal-btn')
    const el2 = document.querySelector('#event-details__name')
    scrollToView(el)
    scrollToView(el2)
  }
  const setTicketValue = (i, func) => {
    var ticketList = document.getElementsByClassName('ticket-order-value')
    if (func === 'increment') {
      ticketList[i].innerHTML = Number(ticketList[i].innerHTML) + 1
    } else {
      if (Number(ticketList[i].innerHTML) > 0) {
        ticketList[i].innerHTML = Number(ticketList[i].innerHTML) - 1
      }
    }
    // const document.get
  }

  function isImage(url) {

    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url) || url?.includes('placeimg');
  }


  const toggleShowEventDetails = () => {
    setShowEventDetails(!showEventDetails)
  }
  const toggleChecked = () => {
    setChecked(!checked)
  }

  const toggleCoupon = () => {
    setCoupon(!coupon)
  }
  const changeNavbarColor = () => {
    setColorchange(window.scrollY >= 80);
};

useEffect(() => {
    const handleScroll = () => {
        changeNavbarColor();
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}, []);


  const config = {
    name: selectedEvent?.name,
    description: selectedEvent?.description,
    startDate: selectedEvent?.date,
    endDate: selectedEvent?.date,
    options: ['Google'],
    timeZone: 'Europe/Berlin',
    trigger: 'click',
    iCalFileName: 'Reminder-Event'
  }


  const getAllEvents = async (query, queryType) => {
    try {
      setLoading(true)
      console.log(queryType, query)
      const response = await axios.get(`/event/all?${queryType}=${query}`)
      console.log(response)
      setAllEvents(response.data?.data?.allEvents)
      setFilteredEvents(response.data?.data?.allEvents)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }
 


  setTimeout(function () {
    if (selectedEvent) {
      setActiveSlide(
        activeSlide < selectedEvent?.media.length - 1 ? activeSlide + 1 : 0
      )
    }
  }, 10000)

  const calculateTicketTotalPrice = () => {
    const arr = []
    selectedEvent.tickets.map((el, i) =>
      arr.push(el.price * ticketOrderDetails[i])
    )
    const totalTicketPrice = arr.reduce((x, y) => Number(x) + Number(y))
    setTotalPrice(totalTicketPrice)
  }
  useEffect(() => {
    const mediaQueryList = window.matchMedia('(max-width: 768px)');
    const handleMediaQueryChange = e => setMatches(e.matches);
    mediaQueryList.addEventListener('change', handleMediaQueryChange);

    return () => {
        mediaQueryList.removeEventListener('change', handleMediaQueryChange);
    };
}, []);

  const urlParams = new URLSearchParams(window.location.search)
  const eventName = urlParams.get('event_name')
  const eventCategory = urlParams.get('event_category')

console.log(eventName, eventCategory)

  useEffect(() => {
    if (eventName) {
      getAllEvents(eventName, 'name')
      console.log(getAllEvents)
    } else if (eventCategory) {
      getAllEvents(eventCategory, 'category')
    }

  }, [eventName, eventCategory])




  return (
    <>
      {loading || request || fetching ? (
        <Loader />
      ) : (
        <div
          className='home-section'
          style={{
            minHeight: '100vh'
          }}
        >
          <Header position={'fixed'} activeLink='categories' subPage={false} />


          <section className='upcoming-event-section px-3 px-md-5 pb-5  pt-5 '>
            <div className='  pt-5 '>
              <h3 className='section-title mb-2 text-white'>Search Result</h3>
            </div>
            <div>
              <Row className='g-4'>
                {eventName || eventCategory ?
                  <>
                    {allEvents
                      ?.map(el =>
                        <Col sm='12' md='6' lg='3'>
                          <SearchedEvent event={el}
                            
                            setSelectedEvent={setSelectedEvent}
                            toggleShowEventDetails={toggleShowEventDetails}
                          />
                        </Col>)
                    }
                  </>
                  : null}

                {/*  */}
              </Row>
            </div>
          </section>

          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <Modal
            isOpen={showEventDetails}
            toggle={toggleShowEventDetails}
            size='xl'
            className=' event-details-modal'
            modal-className='event-details-modal'
          >
            {/*  */}

            <EventDetails
              reset={reset}
              init={init}
              coupon={coupon}
              checked={checked}
              toggleChecked={toggleChecked}
              toggleCoupon={toggleCoupon}
              selectedEvent={selectedEvent}
              ticketOrderDetails={ticketOrderDetails}
              setSelectedEvent={setSelectedEvent}
              newFeaturedEvents={newFeaturedEvents}
              setEmail={setEmail}
              setFullname={setFullname}
              setPhone={setPhone}
              toggleSimilarEventDetails={toggleSimilarEventDetails}
              toShowEventDetails={toggleShowEventDetails}
              setShowEventImages={setShowEventImages}
              setTicketOrderDetails={setTicketOrderDetails}
              calculateTicketTotalPrice={calculateTicketTotalPrice}
              error={error}
              setError={setError}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              name={name}
              userEmail={email}
              userPhone={phone}
            />
          </Modal>
          <div
          // style={{
          //   position: 'fixed',
          //   bottom: 0
          // }}
          >
            <Footer />
          </div>


          <MobileMenu toggle={setShowMobileMenu} show={showMobileMenu} />
          {showEventImages && (
            <div className='event-image__lightbox'>
              <ReactImageVideoLightbox
                data={selectedEvent?.media
                  ?.filter(el => !el.includes('mp4'))
                  .map(el => ({
                    url: el,
                    type: el.includes('mp4') ? 'video' : 'photo',
                    altTag: selectedEvent?.name
                  }))}
                startIndex={activeSlide}
                showResourceCount={true}
                onCloseCallback={() => {
                  setShowEventImages(false)
                  handleVideoPlay()
                }}
              />
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default Intent
